import React from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
// import CalendarEmbed from "../components/GoogleCalendar"; // Assuming CalendarEmbed is in CalendarCopmonent.js
import CalendarComponent from "../components/CalendarCopmonent";
export default function CalanderPage() {
  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <h1 className="text-secondary fw-boldest point-42">My Calendar</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div className="">
                    <CalendarComponent /> {/* Embed the CalendarEmbed component here */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}